import { API } from '@Providers';

export default async function (item: number) {
  const endpoint = `/api/shelter/cart/remove-item/${item}`;

  return API({ endpoint });
}
